// src/services/apiService.js
import { format, parse } from "date-fns";
import { fr } from "date-fns/locale";

import axios from "axios";
import { toast } from "react-toastify";

// ==========================================================
//  >>> MODIFIER CETTE VARIABLE POUR CHANGER D'ENVIRONNEMENT
//  "local" : développement local (MAMP sur le port 8888)
//  "prod"  : serveur de production
// ==========================================================
const ENV = "prod"; // "local" | "prod"

const getFullUrl = () => {
  const { protocol, hostname } = window.location;
  if (ENV === "local") {
    return `${protocol}//${hostname}:8888/`;
  }
  return `${protocol}//${hostname}/`;
  //return `https://www.snproveci.com/`;
};

export function formatDateSecond(rawDate) {
  const date = parse(rawDate, "yyyy-MM-dd HH:mm:ss", new Date());
  return format(date, "MMM do, yyyy HH:mm", { locale: fr });
}

export const fullUrl = getFullUrl();
const urlBaseImage = "extranetbackend/backoffice/";
export const rootUrl = fullUrl + "extranetbackend/backoffice/webservices/";

const fetchEvenements = (params) => {
  return axios.post(`${rootUrl}TicketManager.php`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

// Vous pouvez ajouter d'autres fonctions pour d'autres appels API ici
// Par exemple, une fonction pour obtenir les détails d'un événement
const fetchEvenementDetails = (eventId) => {
  const params = {
    mode: "getEvenementDetails",
    LG_EVENID: eventId,
    //STR_UTITOKEN: 'wzpjku2dvokriz3phgop',
  };

  return axios.post(`${rootUrl}TicketManager.php`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const doConnexion = (params) => {
  return axios.post(`${rootUrl}Authentification.php`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const doDisConnexion = (params) => {
  return axios.post(`${rootUrl}Authentification.php`, params, {
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
  });
};

const crudData = (params, apiUrl, multipart = true) => {

  const token = localStorage.getItem("jwt_token"); // Ajouté 20/04/2026

  // let headers = {
  //     "Content-Type": "multipart/form-data",
  // };

  // if (multipart === false) {
  //     headers = {
  //         "Content-Type": "application/x-www-form-urlencoded",
  //     };
  // }

  const headers = {}

  if (multipart) {
    headers["Content-Type"] = "multipart/form-data"
  } else {
    headers["Content-Type"] = "application/x-www-form-urlencoded"
  }

  // ← Ajouter le JWT si disponible - 20/04/2026
  if (token) {
    headers["Authorization"] = `Bearer ${token}`;
  }

  return axios.post(`${rootUrl}${apiUrl}`, params, { headers });
};

export const formatDateOriginal = (date) => {
  const newDate = new Date(date)
  const formattedDate = newDate.toLocaleDateString("fr-FR", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
  })

  return formattedDate
}

const currentYear = new Date().getFullYear() // Obtenir l'année en cours
const firstDayOfYear = new Date(currentYear, 0, 1) // 1er janvier de l'année en cours
const today = new Date() // Date du jour

// Formater les dates en 'YYYY-MM-DD' (en retirant la partie heure)
const formatDate = (date) => date.toISOString().split("T")[0]

export function convertToFormData(data) {
  const formData = new FormData()

  // Parcourir les clés de l'objet principal
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      // Si la clé est un tableau (par ex: "documents")
      data[key].forEach((item, index) => {
        Object.keys(item).forEach((subKey) => {
          formData.append(`${key}[${index}][${subKey}]`, item[subKey])
        })
      })
    } else {
      // Si ce n'est pas un tableau
      formData.append(key, data[key])
    }
  })

  return formData
}

// Obtenir la date du dernier jour du mois prochain

const nextMonth = new Date(today.getFullYear(), today.getMonth() + 2, 0) // Obtenir le dernier jour du mois prochain
// on peut changer le nombre de mois (2)

// Stocker dans le localStorage
localStorage.setItem("DT_BEGIN", formatDate(firstDayOfYear))
localStorage.setItem("today", formatDate(today))

const date = {
  firstDayOfYear: formatDate(firstDayOfYear),
  // today: formatDate(today),
  today: formatDate(nextMonth),
}

export const adminEmail = "saoured11@gmail.com"

export const mode = {
  listProductMode: "listProduct",
  getProductMode: "getProduct",
  createCommproduittMode: "createCommproduit",
  listCommandeproductMode: "listCommandeproduct",
  deleteCommproduitMode: "deleteCommproduit",
  updateCommproduitMode: "updateCommproduit",
  doConnexionMode: "doConnexion",
  getZoneLivraisonMode: "getDeliveryPlace",
  listProductByCommandeMode: "listProductOnOrder",
  listLastestItemsMode: "listLastestItems",
  listInvoicesMode: "listInvoices",

  getClientPanierMode: "getClientPanier",
  validationCommandeMode: "validationCommande",
  getExternalClientPanierMode: "getExternalClientPanier",
  listClientCommandeMode: "listOrdersIn",
  getCalendarMode: "getCalendar",
  getClientCalendarMode: "getClientCalendar",
  getProductsMode: "getProducts",
  listDocumentsMode: "listDocuments",
  listElementsMode: "listElements",
  getSubstitutionProductsMode: "getSubstitutionProducts",
  getProductByCategoryMode: "getProductByCategory",
  showAllProductImagesMode: "showAllProductImages",

  listCategorieplaceEvenementMode: "listCategorieplaceEvenement",
  getProductListGammeAndCategoryMode: "getProductListGammeAndCategory",
  markProductAsViewedMode: "markProductAsViewed",

  getCalendarFrontOfiiceMode: "getCalendarFrontOfiice",
}

export const paths = {
  signIn: "/",
  saveEvent: "/save-event",
  eventDetails: "/event-details",
  eventList: "/liste-evenement",
  saveBanner: "/save-banner",
  clientList: "/liste-client",
  ticketList: "/liste-ticket",
  detailClient: "/detail-client",
  mesCommandes: "/mes-commandes",

  dashboard: "/tableau-bord",
  saveEventData: "/save-event-data",
  listeEventData: "/liste-event-data",
  saveEventBanner: "/save-event-banner",
  listeEventBanner: "/liste-event-banniere",
  listeUtilisateurs: "/liste-utilisateurs",
  saveUtilisateurs: "/save-utilisateurs",
  notFound: "*",
}

export const apiEndpointe = {
  StockManagerEndPoint: "StockManager.php",
  CommandeManagerEndPoint: "CommandeManager.php",
  ConfigurationManagerEndPoint: "ConfigurationManager.php",
}

export const errorImageUrl = {
  imagePath_404: "assets/images/404.png",
  imagePath_500: "assets/images/500.png",
  imagePath_maintenance: "assets/images/maintenance.png",
}

const userDatas = {
  UTIFIRSTLASTNAME: null,
  UTIPHONE: null,
  UTIMAIL: null,
  UTILOGIN: null,
  UTIPIC: null,
  LG_AGEID: "14226168275285031549",
  STR_UTITOKEN: "c4cd488e9ebde9552879",
  PRODESCRIPTION: "super administrateur",
  PROID: null,
  PROTYPE: "system",
  SOCNAME: "nkm-tech",
  SOCDESCRIPTION: "nkm-technology",
  SOCLOGO: "logo_nkm.png",
  SOCID: "1",
  LG_CLIID: "596",
  code_statut: "1",
  desc_statut: "Bienvenu ngbeadego martial",
  LG_COMMID: "353493",
}

export const defaultImage = "extranetbackend/backoffice/images/default-product-image.jpg"

const imageRuptureStock = "images/produits/AMOXY-C1KG-FACE.jpg"

localStorage.setItem("defaultImage", JSON.stringify(defaultImage))
localStorage.setItem("imageRuptureStock", imageRuptureStock)
// localStorage.setItem("urlBaseImage", fullUrl + urlBaseImage);
localStorage.setItem("urlBaseImage", "/images/img1.jpeg")

// localStorage.setItem('userData', JSON.stringify(userData));
localStorage.setItem("errorImageUrl", JSON.stringify(errorImageUrl))
localStorage.setItem("appPaths", JSON.stringify(paths))
localStorage.setItem("appMode", JSON.stringify(mode))
localStorage.setItem("apiEndpointe", JSON.stringify(apiEndpointe))
localStorage.setItem("appDate", JSON.stringify(date))
localStorage.setItem("appDevise", "GNF")

export { fetchEvenements, fetchEvenementDetails, doConnexion, doDisConnexion, crudData }
export const resetPassword = async (params) => {
  try {
    const baseUrl = "http://localhost/extranetbackend/backoffice/webservices"
    const url = `${baseUrl}/ConfigurationManager.php`

    const formData = new URLSearchParams(params)

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData,
    })

    if (!response.ok) {
      throw new Error(`Erreur HTTP : ${response.status}`)
    }

    // Récupérer le texte de la réponse
    const text = await response.text()
    console.log("Réponse brute de l'API :", text)

    // Vérifier si la réponse contient une erreur PHP
    if (text.includes("Fatal error") || text.includes("Warning") || text.includes("Notice")) {
      return {
        status: response.status,
        data: {
          code_statut: "0",
          desc_statut: "Erreur serveur. Veuillez contacter l'administrateur.",
        },
      }
    }


    if (text.includes("Adresse incorrecte") || text.includes("email incorrecte") || text.includes("n'existe pas")) {
      return {
        status: response.status,
        data: {
          code_statut: "0",
          desc_statut: "Adresse email incorrecte. Veuillez vérifier votre saisie.",
        },
      }
    }

    // Si la réponse contient des indications de succès, considérer comme réussi
    if (
      text.includes("succès") ||
      text.includes("success") ||
      text.includes("réinitialisé") ||
      text.includes("envoyé") ||
      text.includes("email") ||
      text.includes("mot de passe")
    ) {
      return {
        status: response.status,
        data: {
          code_statut: "1",
          desc_statut: "Email de réinitialisation envoyé avec succès",
        },
      }
    }


    try {

      let jsonText = text.trim()


      const firstBrace = jsonText.indexOf("{")
      if (firstBrace > 0) {
        jsonText = jsonText.substring(firstBrace)
      }


      const lastBrace = jsonText.lastIndexOf("}")
      if (lastBrace !== -1 && lastBrace < jsonText.length - 1) {
        jsonText = jsonText.substring(0, lastBrace + 1)
      }

      // Vérifier si le JSON est valide
      if (jsonText.startsWith("{") && jsonText.endsWith("}")) {
        const data = JSON.parse(jsonText)
        console.log("Réponse JSON analysée :", data)
        return { status: response.status, data }
      } else {
        throw new Error("Format JSON invalide")
      }
    } catch (parseError) {
      console.error("Erreur d'analyse JSON :", parseError)


      return {
        status: response.status,
        data: {
          code_statut: "1",
          desc_statut: "Email de réinitialisation envoyé avec succès",
        },
      }
    }
  } catch (error) {
    console.error("Erreur lors de la réinitialisation du mot de passe :", error)
    return {
      status: 500,
      data: {
        code_statut: "0",
        desc_statut: `Erreur: ${error.message}`,
      },
    }
  }
}



export async function GET(request) {
  try {
    const searchParams = request.nextUrl.searchParams;
    const mode = searchParams.get("mode");
    const search = searchParams.get("search") || "";
    const limit = Number.parseInt(searchParams.get("limit") || "20");
    const page = Number.parseInt(searchParams.get("page") || "1");

    if (mode !== "searchProduct") {
      return new Response(JSON.stringify({ error: "Mode non supporté" }), {
        status: 400,
        headers: { "Content-Type": "application/json" },
      });
    }

    // Définition de l'URL de l'API
    const baseUrl = "http://localhost/extranetbackend/backoffice/webservices";
    const url = `${baseUrl}/StockManager.php`;

    // Préparation des paramètres sous format x-www-form-urlencoded
    const formData = new URLSearchParams();
    formData.append("mode", "searchProduct");
    formData.append("search", search);
    formData.append("limit", limit);
    formData.append("page", page);

    const response = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData,
    });

    if (!response.ok) {
      throw new Error(`Erreur HTTP : ${response.status}`);
    }

    // Récupération du texte brut de l'API
    const text = await response.text();
    console.log("Réponse brute de l'API :", text);

    // Vérifier si la réponse contient une erreur PHP
    if (text.includes("Fatal error") || text.includes("Warning") || text.includes("Notice")) {
      return new Response(
        JSON.stringify({
          code_statut: "0",
          desc_statut: "Erreur serveur. Veuillez contacter l'administrateur.",
        }),
        {
          status: 500,
          headers: { "Content-Type": "application/json" },
        }
      );
    }

    // Vérification des erreurs possibles
    if (text.includes("produit introuvable") || text.includes("aucun résultat")) {
      return new Response(
        JSON.stringify({
          code_statut: "0",
          desc_statut: "Aucun produit trouvé.",
        }),
        {
          status: response.status,
          headers: { "Content-Type": "application/json" },
        }
      );
    }

    try {
      let jsonText = text.trim();

      // Nettoyage du JSON en supprimant les éventuels caractères parasites
      const firstBrace = jsonText.indexOf("{");
      if (firstBrace > 0) {
        jsonText = jsonText.substring(firstBrace);
      }

      const lastBrace = jsonText.lastIndexOf("}");
      if (lastBrace !== -1 && lastBrace < jsonText.length - 1) {
        jsonText = jsonText.substring(0, lastBrace + 1);
      }

      // Vérification si le JSON est valide avant parsing
      if (jsonText.startsWith("{") && jsonText.endsWith("}")) {
        const data = JSON.parse(jsonText);
        console.log("Réponse JSON analysée :", data);
        return new Response(JSON.stringify(data), {
          headers: { "Content-Type": "application/json" },
        });
      } else {
        throw new Error("Format JSON invalide");
      }
    } catch (parseError) {
      console.error("Erreur d'analyse JSON :", parseError);

      return new Response(
        JSON.stringify({
          code_statut: "1",
          desc_statut: "Recherche de produit effectuée avec succès",
        }),
        {
          status: response.status,
          headers: { "Content-Type": "application/json" },
        }
      );
    }
  } catch (error) {
    console.error("Erreur lors de la recherche de produits :", error);
    return new Response(
      JSON.stringify({
        code_statut: "0",
        desc_statut: `Erreur: ${error.message}`,
      }),
      {
        status: 500,
        headers: { "Content-Type": "application/json" },
      }
    );
  }
}

// Notifications pour la connexion réseau (Internet)
window.addEventListener("online", () => {
  toast.success("Connexion Internet active", {
    position: "top-right",
    autoClose: 5000,
  });
});

window.addEventListener("offline", () => {
  toast.error("Connexion Internet perdue", {
    position: "top-right",
    autoClose: false, // On garde la notification jusqu'à reconnexion ou fermeture manuelle
  });
});
